import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-jurisdiction-empty-state',
  templateUrl: './jurisdiction-empty-state.component.html',
})
export class JurisdictionEmptyStateComponent {
  @Input({ required: true }) icon: string;
  @Input({ required: true }) title: string;
  @Input() message = '';
  @Input() actionLabel = '';
  @Input() actionLink: string | string[] | null = null;
  @Output() action = new EventEmitter<void>();
}
